import { observer } from "mobx-react-lite";
import * as React from "react";
import { ZAttrMeta } from "src/business/attribute";
import { AttrEdit } from "src/business/attribute/attrEdits";
import { getErrorMessage } from "src/common/onError";

import { evaluateText } from "../../formNav/evaluateText";
import { mfPath2str } from "../../MFormTypes";
import { RenderCtx } from "../../node/MfNode";
import { MfNodeAttr } from "../../node/MfNodeAttr";
import { EntityErrorsView } from "./EntityErrorsView";
import * as styles from "./MfAttrEditor.module.less";

type PropsMfAttrEditor = {
  value: unknown;
  onChange: (newValue: unknown) => void;
  attrMeta: ZAttrMeta;
  node: MfNodeAttr;
  ctx: RenderCtx;
  activateCallback?: (onActive: (() => void) | undefined) => void;
};

export const MfAttrEditor: React.FC<PropsMfAttrEditor> = observer((props) => {
  const { value, onChange, attrMeta, node, ctx, activateCallback } = props;
  const { root } = ctx;
  const title = attrMeta.edit?.title ?? attrMeta.title;
  const textCvt = (text: string): string => evaluateText(text, node, root);
  const required = node.validators.some(({ isRequired }) => isRequired);
  const pathKey = mfPath2str(node.dataPath);
  const error = ctx.errors[pathKey];
  const extErrors = ctx.externalErrorsMap[pathKey];
  const onBlur = () => ctx.touch(pathKey);
  return (
    <div className={styles.attrBox}>
      <div className={styles.attrHeader}>
        {required && <span className={styles.required}>*</span>}
        <div className={styles.attrTitle}>{title}</div>
        <EntityErrorsView extErrors={extErrors} />
        {/* {ctx.isTouched(pathKey) && <u style={{ color: "green" }}>Touched</u>} */}
      </div>
      {attrMeta.type.name === "list" ? (
        <div>Список не поддерживается</div>
      ) : (
        <AttrEdit
          value={value}
          onChange={onChange}
          attr={attrMeta}
          textCvt={textCvt}
          disabled={node.disabled}
          activateCallback={activateCallback}
          onBlur={onBlur}
        />
      )}
      {!!error && ctx.isTouched(pathKey) && (
        <div className={styles.error}>
          {getErrorMessage(error.error).message}
        </div>
      )}
    </div>
  );
});
